import React from "react";
import TopNavigation from "../global_components/TopNavigation";

export const CeTopNavigation = () => {
  return (
    <TopNavigation
      tabs={[
        { to: "/code/list", label: "Code Cases", activeWhenURLIncludes: "/code/list" },
        { to: "/code/reports", label: "Reports", activeWhenURLIncludes: "/code/reports" },
        {
          to: "/ceselectletter.php",
          label: "Letters",
          activeWhenURLIncludes: "ceselectletter.php",
          externalRedirectToLegacyApp: true,
        },
      ]}
    />
  );
};
